import React from "react";
import Button from "@mui/material/Button";
import theme from "../../helpers/theme";

/**
 *
 * @param {String} label text displayed on button
 * @param {Component} children component(s) to display inside button (optional)
 * @param {Any} *** see commonProps for other props that can be injected into Buttons
 * @returns a default styled button
 */
const StyledButton = (props) => {
  let commonProps = {
    onClick: props.onClick,
    component: props.component ? props.component : "button",
    type: "primary",
    variant: props.variant ? props.variant : "contained",
    style: { textTransform: "none" },
    size: props.size ? props.size : "small",
    loading: props.loading ? props.loading : false,
    disabled: props.disabled ? props.disabled : false,
    sx: {
      padding: props.padding ? props.padding : 0.25,
      display: props.display ? props.display : "inline",
      disableElevation: true,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      // set default border to 1 and borderColor to the same as default backgroundColor
      // so that we can add borders to some buttons in a group without changing their
      // dimensions to be different than "non-bordered" buttons.
      border: props.border !== undefined ? props.border : 1,
      borderRadius: props.borderRadius ? props.borderRadius : '4px',
      borderColor: props.borderColor
        ? props.borderColor
        : theme.palette.primary.main,
      boxShadow: "none",
      backgroundColor: props.backgroundColor
        ? props.backgroundColor
        : theme.palette.primary.main,
      color: props.color ? props.color : theme.palette.primary.lighter,
      cursor: props.cursor ? props.cursor : "pointer",
      "&:hover": {
        backgroundColor: props.hoverColor
          ? props.hoverColor
          : theme.palette.primary.dark,
        borderColor: props.hoverBorderColor
          ? props.hoverBorderColor
          : theme.palette.primary.main,
        border: props.hoverBorder ? props.hoverBorder : 1,
        boxShadow: "none",
      },
      fontSize: props.fontSize ? props.fontSize : 12,
      height: props.height ? props.height : "100%",
      width: props.width ? props.width : "100%",
    },
  };

  // setup another common config
  if (props.customTheme == "outlined") {
    commonProps.sx.backgroundColor = theme.palette.secondary.lighter;
    commonProps.sx["&:hover"].backgroundColor = theme.palette.secondary[200];
    commonProps.sx.color = theme.palette.secondary[600];
    commonProps.sx.borderColor = theme.palette.secondary[500];
    commonProps.variant = "outlined";
  }
  if (props.customTheme == "delete") {
    commonProps.sx.backgroundColor = "white";
    commonProps.sx["&:hover"].backgroundColor = theme.palette.secondary.light;
    commonProps.sx["&:hover"].borderColor = "red";
    commonProps.sx.color = "red";
    commonProps.sx.borderColor = "red";
    commonProps.variant = "outlined";
  }
  
  

  if (props.children) {
    return <Button {...commonProps}>{props.children}</Button>;
  } else {
    return <Button {...commonProps}>{props.label}</Button>;
  }
};

export default StyledButton;
